<div class="sis-info">
  <h2>{{ title }}</h2>
  <p [innerHTML]="linkedText"></p>

  <div class="sis-info-buttons">
    <ion-button size="medium" color="#ffffff" fill="solid" (click)="close()"> OK </ion-button>
  </div>
</div>
